import React from 'react';
import LogoPreview from './LogoPreview';

const ReadonlyState = ({ logo }) => (
	<LogoPreview src={logo.src} alt={logo.name || logo.file} height={88} />
);

export default ReadonlyState;
